<section class="container-fluid backgroundColor shark darken-3 position-relative top-119" id="my-element">
  <div class="row">
    <div class="col-md-6 text-white no-padd img-mobile-view">
      <img src="../../assets/images/services/manutencao.jpg" class="img-fluid img-penhalonga" alt="" srcset="">
    </div>
    <div class="col-md-6 text-center no-padd text-mobile-view">
      <ul class="list-group list-group-flush mt-16">
        <li class="list-group-item textColor new-orleans base border-0">
        </li>
        <li class="list-group-item textColor new-orleans base border-0">
          <h1>Serviços de Garantia, Assistência Técnica <br> Manutenção de Mecanismos de Tempo e Relógios</h1>
        </li>
        <li class="list-group-item border-0 text-white">Porque estamos junto dos nossos clientes sempre que precisem, <br> pois o tempo está do nosso lado.</li>
        <li class="list-group-item border-0 text-white">Dispomos de profissionais experientes, credenciados e habilitados <br> pelas melhores Marcas para cuidar dos seus relógios e joias.</li>
        <a href="contactus#messageUs" class="mt-5 mb-5">
          <button class="btn from-left border-size">
            <h1>Contacte-nos</h1>
          </button>
        </a>
      </ul>
    </div>
  </div>
</section>
<section class="container-fluid bg-gradient-reverse position-relative top-119 nav-border-bottom">
  <div class="row">
    <div class="col-md-6 text-center no-padd text-mobile-view-2 -mt-16">
      <ul class="list-group list-group-flush mt-20">
        <li class="list-group-item textColor new-orleans base border-0">
          <br><br>
        </li>
        <li class="list-group-item  textColor new-orleans base border-0">
          <h1>Criação e Personalização de Joias</h1>
        </li>
        <li class="list-group-item border-0 text-white">Porque a sua ideia será única, o seu desenho imaginado tornado real, <br> estaremos consigo quando desejar assinalar o momento marcante na sua vida.</li>
        <a href="contactus#messageUs" class="mt-8">
          <button class="btn from-left border-size btn-pos">
            <h1>Contacte-nos</h1>
          </button>
        </a>
      </ul>
    </div>
    <div class="col-md-6 text-white no-padd">
      <img src="../../assets/images/services/personalizacao.jpg" class="img-fluid img-mobile-view-2" alt="" srcset="">
    </div>
  </div>
</section>
<div class="backgroundColor mine-shaft base h-96">
  <section class="container-fluid  backgroundColor mine-shaft base position-relative -top-172 pb-5" id="messageUs">
    <div class="row">
      <div class="col-md-6 text-white no-padd">
        <img src="../../assets/images/services/clean.jpg" class="img-fluid img-clean" alt="" srcset="">
      </div>
      <div class="col-md-6 pt-5 text-center no-padd -mt-10">
        <ul class="list-group list-group-flush">
          <li class="list-group-item textColor new-orleans base border-0">
          </li>
          <li class="list-group-item textColor new-orleans base border-0">
            <h1>Recuperação e Limpeza de Joias</h1>
          </li>
          <li class="list-group-item border-0 text-white">Porque o tempo passa mas as suas joias ficam, nós cuidamos delas <br> para que as possam manter perfeitas, como deseja.</li>
          <a href="contactus#messageUs" class="mt-5">
            <button class="btn from-left border-size">
              <h1>Contacte-nos</h1>
            </button>
          </a>
        </ul>
      </div>
    </div>
  </section>
</div>